
    import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
    import api from "@/api";
    import store from "@/store";
    import { Message } from "element-ui";

    @Component({
        name: "list",
        components: {}
    })

    export default class extends Vue {
        // 字典
        config: any = store.state.system.config
        // 表格数据
        tableData = [];
        invoiceData: any = []
        // 加载状态
        loading = false;
        // 总条数
        total = 0;
        // 搜索条件
        search = {
            keyword: '',
            status: '',
            type: '',
            created_at: [],
            success_at: [],
            pagination: {
                page: 0, //页码，从0开始
                pageSize: 10, //每页数量
            },
        };

        // 冲红
        ch(id: any) {
            this.$confirm('确认冲红？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                api.post('A11007',{id}).then(res => {
                    this.$message.success('操作成功');
                    this.searchTable()
                })

            })
        }

        // 开票
        kp(id: any) {
            this.$confirm('确认开票？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                api.post('A11005',{id}).then(res => {
                    this.$message.success('操作成功');
                    this.searchTable()
                })

            })
        }

        // 取消
        cancle(id: any) {
            this.$confirm('确认取消？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                api.post('A11006',{id}).then(res => {
                    this.$message.success('操作成功');
                    this.searchTable()
                })
            })

        }
        // 标注
        bz(id: any) {
            this.$prompt('', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPlaceholder: '请输入标注'
            }).then(({ value }: any) => {
                api.post('A11009', {id, desc: value}).then(res => {
                    this.$message.success('操作成功');
                    this.searchTable()
                })

            })
        }

        // 查看
        detailDialog = false
        detailInfo = {}
        toDetail(id: any) {
            api.post('A11003', {id}).then(res => {
                this.detailInfo = res
                if(res.invoice_code) {
                    this.invoiceData = [{invoice_code: res.invoice_code, invoice_number: res.invoice_number}]
                }

                this.detailDialog = true
            })

        }
        //日志
        logDialog = false
        logTable = []
        logTotal = 0
        logSearch = {
            id: '',
            pagination: {
                page: 0,
                pageSize: 20
            }
        }
        toLog(id: any) {
            this.logSearch.id = id
            api.post('A11004', this.logSearch).then(res => {
                this.logTable = res.list
                this.logTotal = res.logTotal
                this.logDialog = true
            })
        }

        // 搜索 search:true 重置翻页
        searchTable(search = false) {
            this.loading = true;
            if (search) {
                this.search.pagination = {
                    pageSize: 20,
                    page: 0,
                };
            }
            api
                .post("A11001", this.search)
                .then((data: any) => {
                    this.total = data.total;
                    this.tableData = data.list;
                })
                .finally(() => {
                    this.loading = false;
                });
        }

        activated() {
            this.searchTable();
        }
    }
